import React from 'react';
import cn from 'classnames';
import Tag from 'components/UI/Tag';
import Hint from 'components/UI/Hint';
import Markup from 'components/Markup';
import { observer } from 'store';
import { useTrans } from 'utils/localisation';
import { getInputControls } from '../utils';
import * as styles from './TagsGroup.module.scss';

const TagsGroup = ({ className, type, label, options, inModal }) => {
  const t = useTrans(['common', 'pricingCalculator']);
  const { getValue, handleChange } = getInputControls(type, label);

  return (
    <div className={cn(styles.formSelect, className)} role="group" aria-labelledby="checkbox-group">
      {options?.map(tag => (
        <label key={tag} className={styles.checkbox}>
          <Tag
            key={tag}
            type="button"
            onClick={() => handleChange(tag)}
            active={getValue(tag)}
            theme="calculatorTag"
            mods="withoutMT"
          >
            {tag}
          </Tag>
        </label>
      ))}
      {label === 'duration' ? (
        <div className={styles.monthsWrapper}>
          {t('months')}
          <Hint
            hintInsideModal={inModal}
            withIcon
            className={styles.tooltipWrapper}
            content={<Markup className={styles.tooltipContent}>{t('durationTooltip')}</Markup>}
            placement={inModal ? 'center' : 'start'}
          />
        </div>
      ) : null}
    </div>
  );
};

export default observer(TagsGroup);
